<app-header></app-header>

<ngx-spinner></ngx-spinner>
  <div class="row pb-2 mt-4 ml-1 mr-1">
    <div class="col">
      <h4>
        <div>{{ CreateShowHide ? 'Add Product' : UpdateShowHide ? 'Edit Product': 'Products'}} </div>
      </h4>
    </div>
</div>

<div class="row mb-2 ml-1 mr-1">
  <div class="col-sm-3">
    <input type="text" *ngIf="!(CreateShowHide || UpdateShowHide)" class="form-control" placeholder="Search" [(ngModel)]="filter">
  </div>
  <div class="col">
    <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" aria-controls="AddProduct" (click)="AddProduct()">
      <i class="fas fa-plus-circle"></i> <span>Add Product</span>
    </button>
  </div>
</div>
<form [formGroup]="frmProduct" *ngIf="CreateShowHide || UpdateShowHide" >
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        
        <div class="form-group col-lg-2" *ngIf="CreateShowHide === false">
          <label for="txtNomenclature" class="form-label">Nomenclature</label>
          <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature" readonly="readonly">
        </div>
        <div class="form-group col-lg-2" *ngIf="CreateShowHide === true">
          <label for="txtNomenclature" class="control-label required">Nomenclature</label><span style="color:red;"> *</span>
          <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature">
          <div *ngIf="frmProduct.get('Nomenclature').invalid && frmProduct.get('Nomenclature').touched"  class="validation">
          <small *ngIf="frmProduct.get('Nomenclature').errors.required">
            Must be required!!!
          </small>
          <small *ngIf="frmProduct.get('Nomenclature').errors.minlength">
            Length must be greater then {{frmProduct.get('Nomenclature').errors.minlength.requiredLength}}.
              Now length is {{frmProduct.get('Nomenclature').errors.minlength.actualLength}}
            </small>
          </div>
        </div>

        <div class="form-group col-lg-2" *ngIf="CreateShowHide === true">
          <label for="txtPrintGroup" class="control-label required">Print Group</label><span style="color:red;"> *</span>
          <select class="form-control" formControlName="PrintGroup" id="txtPrintGroup">
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="printgroup.PrintGroup1" *ngFor="let printgroup of printgroups">
              {{printgroup.PrintGroup1}} </option>
          </select>
          <div *ngIf="frmProduct.get('PrintGroup').invalid && frmProduct.get('PrintGroup').touched"  class="validation">
            <small *ngIf="frmProduct.get('PrintGroup').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('PrintGroup').errors.minlength">
              Length must be greater then {{frmProduct.get('PrintGroup').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('PrintGroup').errors.minlength.actualLength}}
            </small>
          </div>
        </div>
        <div class="form-group col-lg-2" *ngIf="CreateShowHide === false">
          <label for="txtPrintGroup" class="form-label">Print Group</label>
              <input readonly="readonly" class="form-control" formControlName="PrintGroup" id="txtPrintGroup">
        </div>

        <div class="form-group col-lg-3">
          <label for="txtTitle" class="control-label required">Title</label><span style="color:red;"> *</span>
          <input type="text" class="form-control" id="txtTitle" formControlName="Title">
          <div *ngIf="frmProduct.get('Title').invalid && frmProduct.get('Title').touched"  class="validation">
            <small *ngIf="frmProduct.get('Title').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('Title').errors.minlength">
              Length must be greater then {{frmProduct.get('Title').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('Title').errors.minlength.actualLength}}
            </small>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">

        <div class="form-group col-lg-2">
          <label for="txtProductCategory" class="control-label required" >Product Category</label><span style="color:red;"> *</span>
          <select class="form-control" (change)="UpdateAvailableCategories()" formControlName="ProductCategoryId" id="txtProductCategory">
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="category.id" *ngFor="let category of categories">{{category.productCategory1}}
            </option>
          </select>
          <div *ngIf="frmProduct.get('ProductCategoryId').invalid && frmProduct.get('ProductCategoryId').touched"  class="validation">
            <small *ngIf="frmProduct.get('ProductCategoryId').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('ProductCategoryId').errors.minlength">
              Length must be greater then {{frmProduct.get('ProductCategoryId').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('ProductCategoryId').errors.minlength.actualLength}}
            </small>
          </div>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtProductSubCategory" class="control-label required" >Subcategory</label><span style="color:red;"> *</span>
          <select class="form-control" formControlName="ProductSubCategoryId" id="txtProductSubCategory">
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="subcategory.id" *ngFor="let subcategory of availableSubCategories">
                {{subcategory.productSubCategory1}}
              </option>
          </select>
          <div *ngIf="frmProduct.get('ProductSubCategoryId').invalid && frmProduct.get('ProductSubCategoryId').touched"  class="validation">
            <small *ngIf="frmProduct.get('ProductSubCategoryId').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('ProductSubCategoryId').errors.minlength">
              Length must be greater then {{frmProduct.get('ProductSubCategoryId').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('ProductSubCategoryId').errors.minlength.actualLength}}
            </small>
          </div>
        </div>

        <div class="form-group col-lg-2" style="display: none;">
          <label for="txtProductName">ProductName</label>
          <input type="text" class="form-control" id="txtProductName" formControlName="ProductName">
        </div>

        <div class="form-group col-lg-2">
          <label for="txtMaterial" class="control-label required" >Material </label><span style="color:red;"> *</span>
          <select class="form-control" formControlName="MaterialId" id="txtMaterial" required>
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="material.id" *ngFor="let material of materials">{{material.material1}} </option>
          </select>
          <div *ngIf="frmProduct.get('MaterialId').invalid && frmProduct.get('MaterialId').touched"  class="validation">
            <small *ngIf="frmProduct.get('MaterialId').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('MaterialId').errors.minlength">
              Length must be greater then {{frmProduct.get('MaterialId').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('MaterialId').errors.minlength.actualLength}}
            </small>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
       
        <div class="form-group col-lg-2">
          <label for="txtSize">Size</label>
          <input type="text" class="form-control" id="txtSize" formControlName="Size">
        </div>
       
        <div class="form-group col-lg-2">
          <label for="txtLidColor">Lid Color</label>
          <input type="text" class="form-control" id="txtLidColor" formControlName="LidColor">
        </div>
       
        <div class="form-group col-lg-2">
          <label for="txtCupHeight">Cup Height</label>
          <input type="text" class="form-control" id="txtCupHeight" formControlName="CupHeight">
        </div>
       
        <div class="form-group col-lg-2">
          <label for="txtFlushFill">Flush Fill</label>
          <input type="text" class="form-control" id="txtFlushFill" formControlName="FlushFill">
        </div>
      
      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        
        <div class="form-group col-lg-2">
          <label for="txtPracticalFill">Practical Fill</label>
          <input type="text" class="form-control" id="txtPracticalFill" formControlName="PracticalFill">
        </div>
        
        <div class="form-group col-lg-2">
          <label for="txtWidthAtBottom">Width At Bottom</label>
          <input type="text" class="form-control" id="txtWidthAtBottom" formControlName="WidthAtBottom">
        </div>
        
        <div class="form-group col-lg-2">
          <label for="txtWidthAtRim">Width At Rim</label>
          <input type="text" class="form-control" id="txtWidthAtRim" formControlName="WidthAtRim">
        </div>
        
        <div class="form-group col-lg-2">
          <label for="txtItemDimensions">Item Dimensions</label>
          <input type="text" class="form-control" id="txtItemDimensions" formControlName="ItemDimensions">
        </div>

      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        
        <div class="form-group col-lg-4">
          <label for="txtIsEcotainer">Is Ecotainer</label>
          <input type='checkbox'   formControlName='IsEcotainer'/>
        </div>

        <div class="form-group col-lg-4">
          <label for="txtIsCompliancePackaging">Is Compliance Packaging</label>
          <input type='checkbox'  formControlName='IsCompliancePackaging'/>
        </div>

      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        <div class="form-group col-lg-8">
          <label for=txtFeaturesBenefits class="control-label required" >Features & Benefits</label><span style="color:red;"> *</span>
          <ckeditor [config]="{ toolbar:['heading', 'bold', 'italic', 'link', 'undo', 'redo', 'numberedList', 'bulletedList' ] }" [editor]="Editor" id="txtFeaturesBenefits" formControlName="FeaturesBenefits" required aria-label="With textarea">
          </ckeditor>
          <div *ngIf="frmProduct.get('FeaturesBenefits').invalid && frmProduct.get('FeaturesBenefits').touched"  class="validation">
            <small *ngIf="frmProduct.get('FeaturesBenefits').errors.required">
              Must be required!!!
            </small>
            <small *ngIf="frmProduct.get('FeaturesBenefits').errors.minlength">
              Length must be greater then {{frmProduct.get('FeaturesBenefits').errors.minlength.requiredLength}}.
                Now length is {{frmProduct.get('FeaturesBenefits').errors.minlength.actualLength}}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        <div class="form-group col-lg-8">
          <button type="button" class="btn btn-success" (click)="fileInput.click()" >Choose File</button><span style="color:red;"> *</span>
          <input  hidden #fileInput type="file" accept=".jpg" id="file" formControlName="ProductImage" (change)="setFilename(fileInput.files)" />
          <label >{{ this.filename }}</label>
          <img *ngIf="isShown" src="{{baseUrl + this.productname}}" style="max-width:20%; height: auto;" alt="{{this.productname}}" title="{{this.productname}}">
        </div>
        <div *ngIf="frmProduct.get('ProductImage').invalid && frmProduct.get('ProductImage').touched"  class="validation">
          <small *ngIf="frmProduct.get('ProductImage').errors.required">
            Must be required!!!
          </small>
        </div>
      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1">
      <div class="col">
        <button type="button" class="btn btn-success" [disabled]="frmProduct.invalid" *ngIf="CreateShowHide" (click)="CreateProduct(fileInput.files)">
          <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
        </button>
        <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateProduct(fileInput.files)">
          <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
        </button>  
        <a>
          <button type="button" aria-controls="addProduct" *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
            <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
          </button>
        </a>
      </div>
  </div>
</form>
<!-- <div class="row pb-2">
  <div class="col">
    <h4>Products</h4>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-3">
    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="filter">
  </div>
  <div class="col">
    <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" data-toggle="modal"
      data-target="#addProduct" aria-controls="AddProduct" (click)="AddProduct()"><i class="fas fa-plus-circle"></i> Add
      Product</button>

  </div>
</div>
<div class="modal fade" id="addProduct" tabindex="-1" #addProduct aria-labelledby="addProductTitle" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addProductTitle">Enter Product Info</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="frmProduct">

          <div class="form-row">

            <div class="col-md-4 mb-2" *ngIf="CreateShowHide === false ">
              <label for="txtNomenclature" class="form-label">Nomenclature</label>
              <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature"
                readonly="readonly">
            </div>


            <div class="col-md-4 mb-2" *ngIf="CreateShowHide === true">
              <label for="txtNomenclature" class="control-label required">Nomenclature</label>
              <input type="text" class="form-control" id="txtNomenclature" formControlName="Nomenclature">
              <div *ngIf="frmProduct.get('Nomenclature').invalid && frmProduct.get('Nomenclature').touched"  class="validation">
              <small *ngIf="frmProduct.get('Nomenclature').errors.required">
                Must be required!!!
              </small>
              <small *ngIf="frmProduct.get('Nomenclature').errors.minlength">
                Length must be greater then {{frmProduct.get('Nomenclature').errors.minlength.requiredLength}}.
                  Now length is {{frmProduct.get('Nomenclature').errors.minlength.actualLength}}
                </small>
              </div>
            </div>

            <div class="col-md-4 mb-2" *ngIf="CreateShowHide === true ">
              <label for="txtPrintGroup" class="control-label required">Print Group</label>
              <select class="form-control" formControlName="PrintGroup" id="txtPrintGroup">
                <option selected disabled value="">Choose...</option>
                <option [ngValue]="printgroup.PrintGroup1" *ngFor="let printgroup of printgroups">
                  {{printgroup.PrintGroup1}} </option>
              </select>
              <div *ngIf="frmProduct.get('PrintGroup').invalid && frmProduct.get('PrintGroup').touched"  class="validation">
                <small *ngIf="frmProduct.get('PrintGroup').errors.required">
                  Must be required!!!
                </small>
                <small *ngIf="frmProduct.get('PrintGroup').errors.minlength">
                  Length must be greater then {{frmProduct.get('PrintGroup').errors.minlength.requiredLength}}.
                    Now length is {{frmProduct.get('PrintGroup').errors.minlength.actualLength}}
                  </small>
                </div>
            </div>

            <div class="col-md-4 mb-2" *ngIf="CreateShowHide === false ">
              <label for="txtPrintGroup" class="form-label">Print Group</label>
              <input readonly="readonly" class="form-control" formControlName="PrintGroup" id="txtPrintGroup">
            </div>



            <div class="col-md-4 mb-2">
              <label for="txtTitle" class="control-label required">Title</label>
              <input type="text" class="form-control" id="txtTitle" formControlName="Title">
              <div *ngIf="frmProduct.get('Title').invalid && frmProduct.get('Title').touched"  class="validation">
                <small *ngIf="frmProduct.get('Title').errors.required">
                  Must be required!!!
                </small>
                <small *ngIf="frmProduct.get('Title').errors.minlength">
                  Length must be greater then {{frmProduct.get('Title').errors.minlength.requiredLength}}.
                    Now length is {{frmProduct.get('Title').errors.minlength.actualLength}}
                  </small>
                </div>
            </div>

            <div class="col-md-4 mb-2">
              <label for="txtProductCategory" class="control-label required" >Product Category</label>
              <select class="form-control" (change)="UpdateAvailableCategories()" formControlName="ProductCategoryId" id="txtProductCategory">
                <option selected disabled value="">Choose...</option>
                <option [ngValue]="category.id" *ngFor="let category of categories">{{category.productCategory1}}
                </option>
              </select>
              <div *ngIf="frmProduct.get('ProductCategoryId').invalid && frmProduct.get('ProductCategoryId').touched"  class="validation">
                <small *ngIf="frmProduct.get('ProductCategoryId').errors.required">
                  Must be required!!!
                </small>
                <small *ngIf="frmProduct.get('ProductCategoryId').errors.minlength">
                  Length must be greater then {{frmProduct.get('ProductCategoryId').errors.minlength.requiredLength}}.
                    Now length is {{frmProduct.get('ProductCategoryId').errors.minlength.actualLength}}
                  </small>
                </div>
            </div>

            <div class="col-md-4 mb-2">
              <label for="txtProductSubCategory" class="control-label required" >Subcategory</label>
              <select class="form-control" formControlName="ProductSubCategoryId" id="txtProductSubCategory">
                <option selected disabled value="">Choose...</option>
                <option [ngValue]="subcategory.id" *ngFor="let subcategory of availableSubCategories">
                    {{subcategory.productSubCategory1}}
                  </option>
              </select>
              <div *ngIf="frmProduct.get('ProductSubCategoryId').invalid && frmProduct.get('ProductSubCategoryId').touched"  class="validation">
                <small *ngIf="frmProduct.get('ProductSubCategoryId').errors.required">
                  Must be required!!!
                </small>
                <small *ngIf="frmProduct.get('ProductSubCategoryId').errors.minlength">
                  Length must be greater then {{frmProduct.get('ProductSubCategoryId').errors.minlength.requiredLength}}.
                    Now length is {{frmProduct.get('ProductSubCategoryId').errors.minlength.actualLength}}
                  </small>
                </div>
            </div>

            <div class="col-md-4" style="display: none;">
              <label for="txtProductName">ProductName</label>
              <input type="text" class="form-control" id="txtProductName" formControlName="ProductName">
            </div>



            <div class="col-md-3 mb-2">
              <label for="txtMaterial" class="control-label required" >Material </label>
              <select class="form-control" formControlName="MaterialId" id="txtMaterial" required>
                <option selected disabled value="">Choose...</option>
                <option [ngValue]="material.id" *ngFor="let material of materials">{{material.material1}} </option>
              </select>
              <div *ngIf="frmProduct.get('MaterialId').invalid && frmProduct.get('MaterialId').touched"  class="validation">
                <small *ngIf="frmProduct.get('MaterialId').errors.required">
                  Must be required!!!
                </small>
                <small *ngIf="frmProduct.get('MaterialId').errors.minlength">
                  Length must be greater then {{frmProduct.get('MaterialId').errors.minlength.requiredLength}}.
                    Now length is {{frmProduct.get('MaterialId').errors.minlength.actualLength}}
                  </small>
                </div>
            </div>


            <div class="col-md-3 mb-2">
              <label for="txtSize">Size</label>
              <input type="text" class="form-control" id="txtSize" formControlName="Size">
            </div>

            <div class="col-md-3 mb-2">
              <label for="txtLidColor">Lid Color</label>
              <input type="text" class="form-control" id="txtLidColor" formControlName="LidColor">
            </div>

            <div class="col-md-3 mb-2">
              <label for="txtCupHeight">Cup Height</label>
              <input type="text" class="form-control" id="txtCupHeight" formControlName="CupHeight">
            </div>

            <div class="col-md-3 mb-2">
              <label for="txtFlushFill">Flush Fill</label>
              <input type="text" class="form-control" id="txtFlushFill" formControlName="FlushFill">
            </div>

            <div class="col-md-3 mb-2">
              <label for="txtPracticalFill">Practical Fill</label>
              <input type="text" class="form-control" id="txtPracticalFill" formControlName="PracticalFill">
            </div>
            <div class="col-md-3 mb-2">
              <label for="txtWidthAtBottom">Width At Bottom</label>
              <input type="text" class="form-control" id="txtWidthAtBottom" formControlName="WidthAtBottom">
            </div>
            <div class="col-md-3 mb-2">
              <label for="txtWidthAtRim">Width At Rim</label>
              <input type="text" class="form-control" id="txtWidthAtRim" formControlName="WidthAtRim">
            </div>
            <div class="col-md-3 mb-2">
              <label for="txtItemDimensions">Item Dimensions</label>
              <input type="text" class="form-control" id="txtItemDimensions" formControlName="ItemDimensions">
            </div>
            <div class="col-md-4 mb-2">
              <label for="txtIsEcotainer">Is Ecotainer</label>
              <input type='checkbox'   formControlName='IsEcotainer'/>
            </div>
            <div class="col-md-4 mb-2">
              <label for="txtIsCompliancePackaging">Is Compliance Packaging</label>
              <input type='checkbox'  formControlName='IsCompliancePackaging'/>
            </div>
            <div class="col-md-12 mb-2">
              <label for=txtFeaturesBenefits class="control-label required" >Features & Benefits</label>
              <textarea class="form-control" id="txtFeaturesBenefits" formControlName="FeaturesBenefits" required
                aria-label="With textarea"></textarea>
                  <small *ngIf="frmProduct.get('FeaturesBenefits').errors.required">
                    Must be required!!!
                  </small>
                  <small *ngIf="frmProduct.get('FeaturesBenefits').errors.minlength">
                    Length must be greater then {{frmProduct.get('FeaturesBenefits').errors.minlength.requiredLength}}.
                      Now length is {{frmProduct.get('FeaturesBenefits').errors.minlength.actualLength}}
                    </small>
                  </div>
            </div> 
          </div>
          <div class="row">
            <div class="col-md-6">
              <button type="button" class="btn btn-success"
                (click)="fileInput.click()">Choose File</button>
              <input  hidden #fileInput type="file" accept=".jpg" id="file"  (change)="setFilename(fileInput.files)" />
              <label>{{ filename }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-md-6">
                <button type="button" class="btn btn-secondary"[disabled]="frmProduct.invalid" *ngIf="CreateShowHide"
                  (click)="CreateProduct(fileInput.files)">Add</button>
                <button type="button" class="btn btn-secondary"  *ngIf="UpdateShowHide"
                  data-toggle="modal" data-dismiss="modal"
                  (click)="UpdateProduct(fileInput.files)">Update</button>
              </div>
              <div class="col-md-6">
                <button type="button" data-target="#addProduct" data-toggle="modal" aria-controls="addProduct"
                  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-primary" data-dismiss="modal">Cancel</button>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
</div> -->
<div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
  <div class="col">
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover table-sm">
        <thead class="thead-dark">
          <tr>
            <th scope="col" *ngIf="EditShowHide">Actions</th>
            <th scope="col"><span (click)="SortOder('Nomenclature', reverse)">Nomenclature <i
                  class="fas fa-sort"></i></span>
            </th>
            <th scope="col">Print Group <span (click)="SortOder('PrintGroup', reverse)"><i
                  class="fas fa-sort"></i></span></th>
            <!-- <th scope="col">Product Category <span (click)="SortOder('ProductCategory')"><i class="fas fa-sort"></i></span></th>
                            <th scope="col">Product Subcategory<span (click)="SortOder('ProductSubcategory')"><i class="fas fa-sort"></i></span></th> -->
            <th scope="col">Product Name<span (click)="SortOder('ProductName', reverse)"><i
                  class="fas fa-sort"></i></span></th>
            <th scope="col">Title<span (click)="SortOder('Title', reverse)"><i class="fas fa-sort"></i></span></th>
            <!-- <th scope="col">Material<span (click)="SortOder('Material')"><i class="fas fa-sort"></i></span></th> -->
            <th scope="col">Size<span (click)="SortOder('Size', reverse)"><i class="fas fa-sort"></i></span></th>
            <th scope="col">Lid Color<span (click)="SortOder('LidColor', reverse)"><i class="fas fa-sort"></i></span>
            </th>
            <!-- <th scope="col">Features & Benefits<span (click)="SortOder('FeaturesBenefits', reverse)"><i
                  class="fas fa-sort"></i></span></th> -->
            <th scope="col">Cup Height<span (click)="SortOder('CupHeight', reverse)"><i class="fas fa-sort"></i></span>
            </th>
            <th scope="col">Flush Fill<span (click)="SortOder('FlushFill', reverse)"><i class="fas fa-sort"></i></span>
            </th>
            <th scope="col">Practical Fill<span (click)="SortOder('PracticalFill', reverse)"><i
                  class="fas fa-sort"></i></span>
            </th>
            <th scope="col">Width At Bottom<span (click)="SortOder('WidthAtBottom', reverse)"><i
                  class="fas fa-sort"></i></span>
            </th>
            <th scope="col">Width At Rim<span (click)="SortOder('WidthAtRim', reverse)"><i
                  class="fas fa-sort"></i></span></th>
            <th scope="col">Item Dimensions<span (click)="SortOder('ItemDimensions', reverse)"><i
                  class="fas fa-sort"></i></span>
            </th>

            <th scope="col"> Is Ecotainer<span (click)="SortOder('IsEcotainer', reverse)"><i
                  class="fas fa-sort"></i></span></th>
            <th scope="col"> Is Compliance Packaging<span (click)="SortOder('IsCompliancePackaging', reverse)"><i
                  class="fas fa-sort"></i></span></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items |stringFilter: filter | paginate: config ">
            <td *ngIf="EditShowHide">
              <table>
                <tr>
                  <td>
                    <button type="button" data-target="#addProduct" data-toggle="modal" class="btn btn-info btn-sm"
                            (click)="EditProduct(item)" title="Edit">
                      <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                    </button>
                  </td>
                  <td>
                    <button class="btn btn-info btn-sm" (click)="DeleteProduct(item.id)" title="Delete">
                      <i class="far fa-trash-alt fa-lg text-danger"></i>
                      <span class="d-none d-md-inline d-lg-inline">Delete</span>
                    </button>
                  </td>
                </tr>
              </table>              
            </td>
            <td>{{item.nomenclature}}</td>
            <td>{{item.printGroup}}</td>
            <!-- <td>{{categories[item.ProductCategoryId].productCategory1}}</td>
                            <td>{{subcategories[item.ProductSubcategoryId].productSubCategory1}}</td> -->
            <td>{{item.productName}}</td>
            <td>{{item.title}}</td>
            <!-- <td>{{item.Material}}</td> -->
            <td>{{item.size}}</td>
            <td>{{item.lidColor}}</td>
            <!-- <td>{{item.featuresBenefits}}</td> -->
            <td>{{item.cupHeight}}</td>
            <td>{{item.flushFill}}</td>
            <td>{{item.practicalFill}}</td>
            <td>{{item.widthatBottom}}</td>
            <td>{{item.widthatRim}}</td>
            <td>{{item.itemDimensions}}</td>
            <td>{{item.isEcotainer}}</td>
            <td>{{item.isCompliancePackaging}}</td>
          </tr>
          <tr>

          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
<div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
  <div class="col mtpx">
    {{
    (config.totalItems === 0) ? 'No records found' : 'Showing ' +
    (
    ((config.currentPage - 1) * config.itemsPerPage + 1) +
    (((config.currentPage * config.itemsPerPage) > config.totalItems) ? ((config.totalItems <= 1 ? '' : ('
      - ' + config.totalItems))) : ((' - ' + config.currentPage
          *
          config.itemsPerPage))) + ' of ' + config.totalItems + ' records.' ) }} </div>
      <div class="col">
        <pagination-controls [id]="config.id" [autoHide]="true" [responsive]="true" (pageChange)="onPageChange($event)"
          (pageBoundsCorrection)="onPageBoundsCorrection($event)" class="pagination justify-content-end mtpx">
        </pagination-controls>
      </div>
  </div>
